import React from 'react';

const MyAuction = (className = '') => (
  <span className={`svg-icon svg-md-icon d-flex align-items-center justify-content-center ${className}`}>
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="32" height="32" rx="5" fill="#F8F9FD" />
        <path
          d="M9.87174 21.7244H16.5384C16.9051 21.7244 17.2051 22.0244 17.2051 22.3911C17.2051 22.7577 16.9051 23.0577 16.5384 23.0577H9.87174C9.50508 23.0577 9.20508 22.7577 9.20508 22.3911C9.20508 22.0244 9.50508 21.7244 9.87174 21.7244ZM12.0317 13.1044L13.9184 11.2177L22.4051 19.7044C22.9251 20.2244 22.9251 21.0711 22.4051 21.5911C21.8851 22.1111 21.0384 22.1111 20.5184 21.5911L12.0317 13.1044ZM17.6917 9.33107L19.5784 11.2177C20.0984 11.7377 20.0984 12.5844 19.5784 13.1044L18.6317 14.0511L14.8651 10.2777L15.8051 9.33773C16.3251 8.81107 17.1717 8.81107 17.6917 9.33107ZM11.0917 14.0444L14.8651 17.8177L13.9251 18.7577C13.4051 19.2777 12.5584 19.2777 12.0384 18.7577L10.1517 16.8711C9.63174 16.3511 9.63174 15.5044 10.1517 14.9844L11.0917 14.0444Z"
          // fill="#FEC900"
          fill="#8996AE"
        />
      </svg>
    </span>
);

export default MyAuction;


